<div class="page">
  <div class="container">
    {{ "PAGE_NOT_AUTHORISED_MESSAGE" | translate }}.
  </div>
</div>